import * as http from "../index";
const buildLookupRequest = ({ requestForgeryToken, }) => http
    .builder()
    .method("get")
    .accept("application/json")
    .requestForgeryToken(requestForgeryToken)
    .build();
const validateResponse = (response) => {
    if (!response || !response.successful || !response.response) {
        throw new Error("The request did not succeed");
    }
    return response.response;
};
export const lookupAddress = (lookupRequest, config) => http
    .captureStateContext(http.json(`${config.getApiAddress()}/v2/address?SocialId=${lookupRequest.personalNumber}`, buildLookupRequest(http.context())))
    .then(validateResponse);
